import { SET_MODAL_USER_DATA } from "../case_types"
 
const othersActions = {
  setIsLoading: (value) => (dispatch, getState) => dispatch({type: 'SET_IS_LOADING', payload: value}),
  setShowLogin: (value) => (dispatch, getState) => dispatch({type: 'SET_SHOW_LOGIN', payload: value}),
  setModalUserData: (value) => (dispatch, getState) => dispatch({type: SET_MODAL_USER_DATA, payload: value})
}
 
export default othersActions
